import { Component } from '@theme/component';

/**
 * A custom element that renders a sticky Add To Cart bar.
 *
 * @extends Component
 */
export default class StickyAddToCart extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    // Teleport to body to escape all stacking contexts
    if (this.parentNode !== document.body) {
      document.body.appendChild(this);
      return; // Will re-trigger connectedCallback
    }

    this.initObserver();
    this.bindEvents();
  }

  initObserver() {
    const targetSelector = this.getAttribute('data-target');
    if (!targetSelector) return;
    
    this.targetElement = document.querySelector(targetSelector);
    if (!this.targetElement) return;

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          // The button has scrolled UP out of view
          this.classList.add('is-visible');
        } else {
          this.classList.remove('is-visible');
        }
      });
    }, {
      root: null,
      threshold: 0,
      rootMargin: '0px'
    });

    this.observer.observe(this.targetElement);
  }

  bindEvents() {
    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.targetElement) {
        // Trigger click on the original add to cart button
        const originalButton = this.targetElement.querySelector('.add-to-cart-button') || this.targetElement;
        if (originalButton && typeof originalButton.click === 'function') {
          originalButton.click();
          this.animateAddToCart(button);
        }
      }
    });
  }

  animateAddToCart(button) {
    if (this.animationTimeout) clearTimeout(this.animationTimeout);
    if (this.cleanupTimeout) clearTimeout(this.cleanupTimeout);

    if (!button.classList.contains('atc-added')) {
      button.classList.add('atc-added');
    }

    this.animationTimeout = setTimeout(() => {
      this.cleanupTimeout = setTimeout(() => {
        button.classList.remove('atc-added');
      }, 10);
    }, 2000); // ADD_TO_CART_TEXT_ANIMATION_DURATION
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
